
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class MaterialOutBOMDialog extends _Ext.BOMEditorDialog<MaterialOutBOMRow> { 
        protected getLocalTextPrefix() { return MaterialOutBOMRow.localTextPrefix; } 
        
    }
}